export function getTelegramWebApp() {
  if (typeof window === 'undefined') return null;
  const app = window.Telegram?.WebApp;
  // Loading the SDK on the website does not make it a Telegram session.
  return app && (app.initData || (app.platform !== 'unknown' && /tgWebAppVersion=/.test(window.location.hash))) ? app : null;
}

export function telegramStartPath(value) {
  if (typeof value !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(value)) return null;
  if (value === 'home') return '/';
  if (['shelf', 'wishlist', 'search', 'friends', 'collections', 'notifications', 'profile', 'fandoms', 'settings'].includes(value)) return `/${value}`;
  const item = /^item_(film|series|game|music|book)_([A-Za-z0-9_-]+)$/.exec(value);
  if (item) return `/item/${item[1]}/${item[2]}`;
  const target = /^(profile|collection|personal|fandom|shared)_([A-Za-z0-9_-]+)$/.exec(value);
  if (target) return `/${({ shared: 'shared-collections', personal: 'collections' })[target[1]] || target[1]}/${target[2]}`;
  return null;
}

export function initializeTelegram() {
  const app = getTelegramWebApp();
  if (!app) return;
  document.documentElement.dataset.telegram = 'true';
  const syncViewport = () => {
    const style = document.documentElement.style;
    if (app.viewportStableHeight > 0) style.setProperty('--polka-viewport-height', `${app.viewportStableHeight}px`);
    for (const side of ['top', 'bottom', 'left', 'right']) {
      // Device cutouts and Telegram controls occupy separate parts of the viewport.
      const inset = (app.safeAreaInset?.[side] || 0) + (app.contentSafeAreaInset?.[side] || 0);
      style.setProperty(`--polka-safe-${side}`, `${inset}px`);
    }
  };
  app.ready();
  app.expand();
  if (app.isVersionAtLeast?.('7.7') && typeof app.disableVerticalSwipes === 'function') {
    app.disableVerticalSwipes();
  }
  syncViewport();
  for (const event of ['viewportChanged', 'safeAreaChanged', 'contentSafeAreaChanged', 'fullscreenChanged', 'fullscreenFailed']) app.onEvent(event, syncViewport);
  if (app.isVersionAtLeast?.('8.0') && typeof app.requestFullscreen === 'function' && !app.isFullscreen) {
    try {
      app.requestFullscreen();
    } catch {
      // Keep the expanded window usable if the client refuses fullscreen.
      syncViewport();
    }
  }
}
